import { createActionGroup, props } from '@ngrx/store';
import { FEATURE_NAME } from './first-class-recipe-base.constant';
import { zefActionFailPayload, zefActionPayload, zefActionSuccessPayload } from '@zerops/zef/core';
import { Process } from '@zerops/models/process';
import { FirstClassPrometheusSuccessResponse } from './first-class-recipe-base.model';

export const FirstClassRecipeBaseActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    // LOGSTASH ACTIONS
    'Deploy Global Elastic Stack with Logstash': props<{
      sourceProjectId: string;
      seriousCore: boolean;
      ha: boolean;
    }>(),
    'Deploy Global Elastic Stack and forward': props<{
      sourceProjectId: string;
      seriousCore: boolean;
      ha: boolean;
    }>(),
    'Forward to global Elastic stack': props<{
      sourceProjectId: string;
      targetProjectId: string;
    }>(),
    'Deploy Dedicated Elastic Stack with Logstash': props<{
      sourceProjectId: string;
      ha: boolean;
    }>(),
    'Deploy Dedicated Elastic Stack and forward': props<{
      sourceProjectId: string;
      ha: boolean;
    }>(),

    // APM ACTIONS
    'Deploy Global Elastic Stack with APM': props<{
      sourceProjectId: string;
      seriousCore: boolean;
      ha: boolean;
    }>(),
    'Deploy Dedicated Elastic Stack with APM': props<{
      sourceProjectId: string;
      ha: boolean;
    }>(),
    'Add APM to Elastic Stack': props<{
      elkProjectId: string;
    }>(),

    // GENERIC
    'First Class Elastic Stack': zefActionPayload<{
      elkProjectId?: string;
      forwardLogsFromProjectId?: string;
      elasticsearchMode?: string;
      projectCorePackage?: string;
      includeLogstash?: boolean;
      includeApm?: boolean;
    }>(),
    'First Class Elastic Stack Fail': zefActionFailPayload,
    'First Class Elastic Stack Success': zefActionSuccessPayload<{ process: Process; }>(),

    // PROMETHEUS ACTIONS
    'Deploy Global Prometheus': props<{
      sourceProjectId: string;
      seriousCore: boolean;
      ha: boolean;
    }>(),
    'Deploy Dedicated Prometheus': props<{
      sourceProjectId: string;
      ha: boolean;
    }>(),
    'Forward to Global Prometheus': props<{
      sourceProjectId: string;
      targetProjectId: string;
      ha?: boolean;
    }>(),

    // GENERIC PROMETHEUS
    'First Class Prometheus': zefActionPayload<{
      prometheusProjectId?: string;
      forwardMetricsFromProjectId?: string;
      grafanaDatabaseMode?: string;
      projectCorePackage?: string;
    }>(),
    'First Class Prometheus Fail': zefActionFailPayload,
    'First Class Prometheus Success': zefActionSuccessPayload<FirstClassPrometheusSuccessResponse>()
  }
});

